import { render } from "./edit-supplier.vue?vue&type=template&id=3f83c73c"
import script from "./edit-supplier.vue?vue&type=script&lang=js"
export * from "./edit-supplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__